import { useTranslation as useI18nTranslation } from 'react-i18next';

export type SupportedLanguage = 'en' | 'de-CH' | 'fr-CH' | 'it-CH';

export const languageConfig = {
  en: { name: 'English', nativeName: 'English', flag: '🇺🇸' },
  'de-CH': {
    name: 'Swiss German',
    nativeName: 'Deutsch (Schweiz)',
    flag: '🇨🇭',
  },
  'fr-CH': {
    name: 'Swiss French',
    nativeName: 'Français (Suisse)',
    flag: '🇨🇭',
  },
  'it-CH': {
    name: 'Swiss Italian',
    nativeName: 'Italiano (Svizzera)',
    flag: '🇨🇭',
  },
} as const;

// Generic translation hook with type safety
export const useTranslation = (namespace?: string) => {
  const { t, i18n } = useI18nTranslation(namespace);

  return {
    t,
    language: i18n.language as SupportedLanguage,
    changeLanguage: (lng: SupportedLanguage) => i18n.changeLanguage(lng),
    isLoading: !i18n.isInitialized,
    isReady: i18n.isInitialized,
  };
};

// Namespace-specific hooks
export const useCommonTranslation = () => useTranslation('common');
export const useFormsTranslation = () => useTranslation('forms');
export const useNavigationTranslation = () => useTranslation('navigation');
export const useErrorsTranslation = () => useTranslation('errors');
